import styled from 'styled-components';
import { proficiencyColors } from 'constants/index';

export const SkillDetailsContainer = styled.div`
  background: white;
  width: 360px;
  position: fixed;
  top: 119.19px;
  bottom: 0;
  right: 0;
  padding: 1rem 0.75rem;
  overflow-y: scroll;
  @media (max-width: 1024px) {
    width: 330px;
  }
`;

export const SkillDetailsHeader = styled.div`
  border-bottom: solid 1px rgba(112, 112, 112, 0.29);
  .skill-name {
    font-size: 1.125rem;
  }
  .skill-number {
    font-size: 0.875rem;
    margin-right: 1rem;
  }
  .skill-description {
    font-size: 0.75rem;
    color: #828282;
  }
  .student-percentage {
    font-size: 1.125rem;
    color: black;
    margin-right: 2rem;
  }
  .class-avg-title {
    font-size: 0.625rem;
    margin-right: 0.5rem;
  }
  .class-avg-percentage {
    font-size: 0.9375rem;
    color: #060606;
  }
  p,
  span {
    font-family: 'Nunito';
    color: #202020;
  }
`;

export const SkillBadge = styled.span`
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background: ${props => proficiencyColors[props.proficiency].color};
  border-radius: 12px;
  border: ${props =>
    `solid 1px ${proficiencyColors[props.proficiency].borderColor}`};
`;

export const QuestionContainer = styled.div`
  color: #202020;
  font-family: 'Nunito';
  margin-top: 1rem;
  .question-title {
    font-size: 0.875rem;
  }
  .question-content {
    font-weight: 600;
    font-size: 1rem;
  }
`;

export const SolutionContainer = styled.div`
  margin-top: 2rem;
  color: #202020;
  font-weight: 600;
  font-family: 'Nunito';
  .solution-title {
    color: #5e925c;
    font-size: 0.875rem;
  }
  .solution-content {
    font-size: 1rem;
  }
`;
